import React, { useEffect, useState } from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";
import { getTokenValidation, setConfirmationAppointment } from "./api/api";
import "./App.css";
import Button from "./components/button";
import CheckBox from "./components/checkBox";

const App = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let token = searchParams.get("k");

  const [gsBaseAppointment, setGsBaseAppointment] = useState();
  const [showConfirm, setShowConfirm] = useState(true);
  const [isAppointmentConfirmed, setIsAppointmentConfirmed] = useState();
  const [textAreaValue, setTextAreaValue] = useState("");
  const [selectedCancelReason, setSelectedCancelReason] = useState();

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    token && getTokenValidation(token, onResponse, onError);
  }, []);

  const checkCancelReasonCheckBox = (reason) => {
    if (JSON.stringify(reason) === JSON.stringify(selectedCancelReason)) {
      return true;
    } else {
      return false;
    }
  };

  const onError = (error) => {
    alert(error);
    window.location.href = "https://clinicaalejandria.es/";
  };

  const onResponse = (response) => {
    let responseGSBase = JSON.parse(response);
    if (responseGSBase.error) {
      onError(responseGSBase.error);
      return;
    }
    if (responseGSBase.message) {
      alert(responseGSBase.message);
      return;
    }
    if (responseGSBase) {
      setGsBaseAppointment(responseGSBase);
      if (responseGSBase.patientFormPending) {
        const newPathname = location.pathname + "formulario/" + "?k=" + token;
        navigate(newPathname, { replace: true });
      }
      if (
        !responseGSBase.confirmAppointment &&
        !responseGSBase.patientFormPending
      ) {
        const newPathname =
          location.pathname + `anular-cita-previa/?k=${token}`;
        navigate(newPathname, { replace: true });
      }
    }
  };

  const onConfirm = () => {
    if (isAppointmentConfirmed === undefined) {
      alert("Por favor, selecciona una respuesta.");
      return;
    }

    if (!isAppointmentConfirmed && !selectedCancelReason) {
      alert("Por favor, selecciona un motivo.");
      return;
    }

    let confirmationAppointment = {
      id: gsBaseAppointment.id,
      confirmation: isAppointmentConfirmed,
      cancelReason: selectedCancelReason,
      observations: textAreaValue,
    };

    setShowConfirm(false);

    setConfirmationAppointment(
      token,
      confirmationAppointment,
      onResponse,
      onError
    );
  };

  return (
    <div className="CAConfirmAppointmentView">
      <iframe
        title="alejandría web"
        className="CAObject"
        src="https://clinicaalejandria.es/"
      ></iframe>
      {gsBaseAppointment && showConfirm && (
        <div className="modalBackgroundContainer">
          <div className="modalContainer">
            <div className="modalTextContainer">
              <div className="modalTitleContainer">CONFIRMAR CITA</div>
              <div className="modalTextNameContainer">
                {gsBaseAppointment?.patient?.name}
              </div>
              <div>
                {`Próximo ${gsBaseAppointment.dayOfWeek} ${gsBaseAppointment.date} a las ${gsBaseAppointment.hour} h. con ${gsBaseAppointment?.doctor?.name}`}
              </div>
            </div>
            <div className="modalCheckBoxContainer">
              <CheckBox
                text={"SÍ"}
                margin={"0 24px 0 0"}
                isChecked={isAppointmentConfirmed === true}
                onChange={() => setIsAppointmentConfirmed(true)}
              />
              <CheckBox
                text={"NO"}
                isChecked={isAppointmentConfirmed === false}
                onChange={() => setIsAppointmentConfirmed(false)}
              />
            </div>
            {isAppointmentConfirmed === false && (
              <>
                <div className="modalReasonTitleContainer">MOTIVO</div>
                {gsBaseAppointment &&
                  gsBaseAppointment.cancelReasonList &&
                  gsBaseAppointment.cancelReasonList.length > 0 && (
                    <div className="modalCancelReasonContainer">
                      {gsBaseAppointment.cancelReasonList.map(
                        (reason, index) => {
                          return (
                            <CheckBox
                              text={reason.title}
                              margin={"0 0 12px 0"}
                              onChange={() => setSelectedCancelReason(reason)}
                              isChecked={checkCancelReasonCheckBox(reason)}
                              key={index}
                            />
                          );
                        }
                      )}
                    </div>
                  )}

                <textarea
                  className="modalTextArea"
                  placeholder={"Escribe el motivo..."}
                  value={textAreaValue}
                  onChange={(event) => setTextAreaValue(event.target.value)}
                />
              </>
            )}
            <Button text={"CONFIRMAR"} onClick={() => onConfirm()} />
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
